import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MediaPage = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("media");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentImageSet, setCurrentImageSet] = useState("dca");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(true);
  }, []);

  const dcaImages = [
    "/images/dca/20250423_102707 (1).jpg",
    "/images/dca/20250424_145940 (1).jpg",
    "/images/dca/20250424_150010 (2).jpg",
    "/images/dca/20250424_150052 (1).jpg",
    "/images/dca/20250424_161801.jpg",
    "/images/dca/20250424_162846 (1).jpg",
    "/images/dca/20250424_163150 (2).jpg",
    "/images/dca/IMG_20250423_102756_edit_732562771877277 (1).jpg",
  ];

  const romaniaImages = [
    "/images/romania-training/20250823_122157.jpg",
    "/images/romania-training/20250823_122225.jpg",
    "/images/romania-training/20250825_161104.jpg",
    "/images/romania-training/20250825_161246.jpg",
    "/images/romania-training/IMG_1239.JPG",
    "/images/romania-training/IMG_1242.JPG",
    "/images/romania-training/IMG_20250829_190350.jpg",
    "/images/romania-training/WhatsApp Image 2025-08-25 at 2.27.08 PM.jpeg",
    "/images/romania-training/WhatsApp Image 2025-08-28 at 6.01.42 PM.jpeg",
    "/images/romania-training/WhatsApp Image 2025-08-28 at 7.03.07 PM.jpeg",
  ];

  const midTermImages = [
    "/images/dca/Mid-term-meeting/DCA%20Post-01.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-02.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-03.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-04.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-05.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-06.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-07.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-08.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-09.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-10.jpg",
    "/images/dca/Mid-term-meeting/DCA%20Post-11.jpg",
  ];

  const tunisiaTrainingImages = [
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-01.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-02.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-03.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-04.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-05.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-06.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-07.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-08.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-09.jpg",
    "/images/dca/Training%20Tunisia/Final/DCA%20Post-10.jpg",
    "/images/dca/Training%20Tunisia/20260328_094740.jpg",
    "/images/dca/Training%20Tunisia/IMG_8329.JPG",
    "/images/dca/Training%20Tunisia/IMG_8351.JPG",
    "/images/dca/Training%20Tunisia/IMG_8355.JPG",
    "/images/dca/Training%20Tunisia/IMG_8370.JPG",
    "/images/dca/Training%20Tunisia/IMG_8374.JPG",
    "/images/dca/Training%20Tunisia/IMG_8410.JPG",
    "/images/dca/Training%20Tunisia/IMG_8482.JPG",
    "/images/dca/Training%20Tunisia/IMG_8497.JPG",
    "/images/dca/Training%20Tunisia/IMG_8508.JPG",
  ];

  const getCurrentImages = () => {
    if (currentImageSet === "dca") return dcaImages;
    if (currentImageSet === "romania") return romaniaImages;
    if (currentImageSet === "midterm") return midTermImages;
    return tunisiaTrainingImages;
  };

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Auto-slider for images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % getCurrentImages().length);
    }, 4000);
    return () => clearInterval(interval);
  }, [currentImageSet]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50">
      {/* Header */}
      <Header
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />

      {/* Hero Section with Image Slider */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-r from-emerald-400/20 to-teal-400/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-r from-teal-400/20 to-cyan-400/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-gradient-to-r from-emerald-300/10 to-teal-300/10 rounded-full blur-3xl animate-pulse delay-500"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left Column - Content */}
            <div
              className={`space-y-8 transition-all duration-1000 ${
                isVisible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-10"
              }`}
            >
              <div className="space-y-6">
                <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-sm font-semibold mb-6">
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                    />
                  </svg>
                  Media & Press
                </div>

                <h1 className="text-6xl md:text-7xl font-bold leading-tight">
                  <span className="block bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 bg-clip-text text-transparent">
                    Project
                  </span>
                  <span className="block text-gray-900 mt-2">Gallery</span>
                </h1>

                <p className="text-xl text-gray-600 leading-relaxed max-w-lg">
                  Explore our visual journey through project milestones,
                  training sessions, and collaborative moments across Europe and
                  the South Mediterranean countries.
                </p>
              </div>

              {/* Gallery Selector */}
              <div className="flex flex-wrap gap-4">
                <button
                  onClick={() => {
                    setCurrentImageSet("dca");
                    setCurrentImageIndex(0);
                  }}
                  className={`group relative px-8 py-4 rounded-2xl font-semibold transition-all duration-300 overflow-hidden ${
                    currentImageSet === "dca"
                      ? "bg-gradient-to-r from-emerald-500 to-teal-500 text-white shadow-xl scale-105"
                      : "bg-white text-gray-700 hover:bg-emerald-50 hover:text-emerald-700 shadow-lg hover:shadow-xl"
                  }`}
                >
                  <span className="relative z-10">Kickoff Meeting</span>
                  {currentImageSet === "dca" && (
                    <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-teal-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  )}
                </button>

                <button
                  onClick={() => {
                    setCurrentImageSet("romania");
                    setCurrentImageIndex(0);
                  }}
                  className={`group relative px-8 py-4 rounded-2xl font-semibold transition-all duration-300 overflow-hidden ${
                    currentImageSet === "romania"
                      ? "bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-xl scale-105"
                      : "bg-white text-gray-700 hover:bg-teal-50 hover:text-teal-700 shadow-lg hover:shadow-xl"
                  }`}
                >
                  <span className="relative z-10">Romania Training</span>
                  {currentImageSet === "romania" && (
                    <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  )}
                </button>

                <button
                  onClick={() => {
                    setCurrentImageSet("midterm");
                    setCurrentImageIndex(0);
                  }}
                  className={`group relative px-8 py-4 rounded-2xl font-semibold transition-all duration-300 overflow-hidden ${
                    currentImageSet === "midterm"
                      ? "bg-gradient-to-r from-cyan-500 to-emerald-500 text-white shadow-xl scale-105"
                      : "bg-white text-gray-700 hover:bg-emerald-50 hover:text-emerald-700 shadow-lg hover:shadow-xl"
                  }`}
                >
                  <span className="relative z-10">Mid-term Meeting</span>
                  {currentImageSet === "midterm" && (
                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  )}
                </button>

                <button
                  onClick={() => {
                    setCurrentImageSet("tunisia");
                    setCurrentImageIndex(0);
                  }}
                  className={`group relative px-8 py-4 rounded-2xl font-semibold transition-all duration-300 overflow-hidden ${
                    currentImageSet === "tunisia"
                      ? "bg-gradient-to-r from-teal-500 to-emerald-500 text-white shadow-xl scale-105"
                      : "bg-white text-gray-700 hover:bg-teal-50 hover:text-teal-700 shadow-lg hover:shadow-xl"
                  }`}
                >
                  <span className="relative z-10">Training Tunisia</span>
                  {currentImageSet === "tunisia" && (
                    <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-emerald-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  )}
                </button>
              </div>
            </div>

            {/* Right Column - Image Slider */}
            <div
              className={`transition-all duration-1000 delay-300 ${
                isVisible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-10"
              }`}
            >
              <div className="relative group">
                <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
                  <div className="relative h-96 md:h-[500px]">
                    <img
                      src={getCurrentImages()[currentImageIndex]}
                      alt={`${currentImageSet} gallery image ${
                        currentImageIndex + 1
                      }`}
                      className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105"
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/800x600/57CC99/FFFFFF?text=Image+Loading...";
                      }}
                    />

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>

                    {/* Navigation Arrows */}
                    <button
                      onClick={() =>
                        setCurrentImageIndex((prev) =>
                          prev === 0 ? getCurrentImages().length - 1 : prev - 1
                        )
                      }
                      className="absolute left-4 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-xl transition-all duration-300 hover:scale-110 opacity-0 group-hover:opacity-100"
                    >
                      <svg
                        className="w-6 h-6 text-gray-700"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 19l-7-7 7-7"
                        />
                      </svg>
                    </button>

                    <button
                      onClick={() =>
                        setCurrentImageIndex((prev) =>
                          prev === getCurrentImages().length - 1 ? 0 : prev + 1
                        )
                      }
                      className="absolute right-4 top-1/2 transform -translate-y-1/2 w-14 h-14 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-xl transition-all duration-300 hover:scale-110 opacity-0 group-hover:opacity-100"
                    >
                      <svg
                        className="w-6 h-6 text-gray-700"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </button>

                    {/* Image Counter */}
                    <div className="absolute bottom-4 right-4 bg-black/60 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium">
                      {currentImageIndex + 1} / {getCurrentImages().length}
                    </div>
                  </div>

                  {/* Thumbnail Strip */}
                  <div className="p-6 bg-gradient-to-r from-gray-50 to-gray-100">
                    <div className="flex space-x-3 overflow-x-auto pb-2">
                      {getCurrentImages().map((image, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentImageIndex(index)}
                          className={`flex-shrink-0 w-16 h-16 rounded-xl overflow-hidden transition-all duration-300 ${
                            index === currentImageIndex
                              ? "ring-4 ring-emerald-500 scale-110 shadow-lg"
                              : "hover:scale-105 hover:shadow-md"
                          }`}
                        >
                          <img
                            src={image}
                            alt={`Thumbnail ${index + 1}`}
                            className="w-full h-full object-cover"
                            loading="lazy"
                            onError={(e) => {
                              e.target.src =
                                "https://via.placeholder.com/64x64/57CC99/FFFFFF?text=IMG";
                            }}
                          />
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Floating Elements */}
                <div className="absolute -top-4 -right-4 w-8 h-8 bg-gradient-to-r from-emerald-400 to-teal-400 rounded-full opacity-60 animate-bounce"></div>
                <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-gradient-to-r from-teal-400 to-cyan-400 rounded-full opacity-60 animate-bounce delay-1000"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Media Resources Section */}
      <section className="pt-12 pb-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-white via-emerald-50/30 to-teal-50/30"></div>

        <div className="relative max-w-6xl mx-auto px-4 md:px-8">
          <div
            className={`text-center mb-16 transition-all duration-1000 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            <h2 className="text-5xl md:text-6xl font-bold mb-6">
              <span className="bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 bg-clip-text text-transparent">
                Media Resources
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Access our newsletters, press coverage, and multimedia content
            </p>
          </div>

          <div
            className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-300 ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"
            }`}
          >
            {/* Newsletter Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              <div className="relative z-10">
                <div className="w-20 h-20 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-2xl flex items-center justify-center text-white mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <svg
                    className="w-10 h-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 10l4.553-2.276A2 2 0 0020 6.382V5a2 2 0 00-2-2H6a2 2 0 00-2 2v1.382a2 2 0 00.447 1.342L9 10m6 0v4a2 2 0 01-2 2H7a2 2 0 01-2-2v-4m6 0l-6-3"
                    />
                  </svg>
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-emerald-700 transition-colors duration-300">
                  Newsletters
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Stay updated with our latest project developments and insights
                </p>

                <button
                  onClick={() => navigate("/news-letters")}
                  className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-6 py-4 rounded-xl font-semibold hover:from-emerald-600 hover:to-teal-600 transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
                >
                  View Newsletter
                </button>
              </div>
            </div>

            {/* Press Coverage Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              <div className="relative z-10">
                <div className="w-20 h-20 bg-gradient-to-r from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center text-white mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <svg
                    className="w-10 h-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                    />
                  </svg>
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-teal-700 transition-colors duration-300">
                  Press Coverage
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Read about our project in media outlets and press releases
                </p>

                <button
                  disabled
                  className="w-full bg-gradient-to-r from-gray-400 to-gray-500 text-white px-6 py-4 rounded-xl font-semibold cursor-not-allowed"
                >
                  Coming soon
                </button>
              </div>
            </div>

            {/* Video Content Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-gray-100">
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

              <div className="relative z-10">
                <div className="w-20 h-20 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl flex items-center justify-center text-white mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                  <svg
                    className="w-10 h-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-emerald-700 transition-colors duration-300">
                  Video Content
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Watch our project videos and multimedia presentations
                </p>

                <button
                  disabled
                  className="w-full bg-gradient-to-r from-gray-400 to-gray-500 text-white px-6 py-4 rounded-xl font-semibold cursor-not-allowed"
                >
                  Coming soon
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
    </div>
  );
};

export default MediaPage;
